// @flow

import * as React from 'react';
import classNames from 'classnames';
import {Heading} from 'docs/components';
import './Aside.scss';

type CalloutProps = {|
  id?: string,
  className?: string,
  children?: React.Node,
  title?: string,
  wide?: Boolean,
|};

export const Aside = ({id, className, title, children, wide}: CalloutProps) => (
  <aside
    id={!title && id ? id : undefined}
    className={classNames('Aside', className, {
      'Aside-wide': wide,
    })}
  >
    {title && (
      <Heading level={3} id={id} anchored>
        {title}
      </Heading>
    )}
    {children}
  </aside>
);
